export enum UserRole {
  UNAPPROVED_DEMO_USER = 'unapproved_demo_user',
  APPROVED_DEMO_USER = 'approved_demo_user',
  BASE_USER = 'base_user',
  STANDARD_USER = 'standard_user',
  INTERNAL_BASE_USER = 'internal_base_user',
  CHEM_USER = 'chem_user',
  CHEM_ADMIN = 'chem_admin',
  ML_DS_USER = 'ml-ds_user',
  ORG_ADMIN = 'org_admin',
  PLATFORM_ADMIN = 'platform_admin',
  SUPER_ADMIN = 'SUPER_ADMIN',
}

export enum PlanType {
  EARLY_ACCESS = 'early_access',
  STANDARD = 'standard',
  ENTERPRISE = 'enterprise',
}

export enum SampleSetStatus {
  UNKNOWN = 'UNKNOWN',
  UPLOAD_SAMPLES = 'UPLOAD_SAMPLES',
  READY = 'READY',
  SAMPLE_WARNING = 'SAMPLE_WARNING',
  SAMPLE_ERROR = 'SAMPLE_ERROR',
  SAMPLE_IN_PROGRESS = 'SAMPLE_IN_PROGRESS',
  JOB_IN_PROGRESS = 'JOB_IN_PROGRESS',
  JOB_SUCCESS = 'JOB_SUCCESS',
  JOB_ERROR = 'JOB_ERROR',
}

export enum SampleStatus {
  UNKNOWN = 'UNKNOWN',
  UPLOADING = 'UPLOADING',
  UPLOADED = 'UPLOADED',
  CONVERTING_TO_MZML = 'CONVERTING_TO_MZML',
  RUNNING_QC_CHECKS = 'RUNNING_QC_CHECKS',
  DONE = 'DONE',
  ERROR = 'ERROR',
  EXCLUDED = 'EXCLUDED',
}

export const SAMPLE_ION_POLARITIES = [
  'pos',
  'neg',
  'pos_neg',
  'pn_switching',
] as const;
export type SampleIonPolarity = (typeof SAMPLE_ION_POLARITIES)[number];

// Mirrors the backend MS_LEVEL StrEnum.
export const MS_LEVELS = ['ms1', 'ms2'] as const;
export type MsLevel = (typeof MS_LEVELS)[number];

export const SAMPLE_ORDER_FIELDS = [
  'created_date',
  'sample_name',
  'polarity',
] as const;
export type SampleOrderField = (typeof SAMPLE_ORDER_FIELDS)[number];

export enum ResultType {
  QUANT = 'QUANT',
  ID = 'ID',
  HYDRA = 'HYDRA',
  ID_PARQUET = 'ID_PARQUET',
  PEPTIDES = 'PEPTIDES',
  MWMINE_FEATURES = 'MWMINE_FEATURES',
}

export enum JobStatus {
  COMPLETED = 'COMPLETED',
  WORKING = 'WORKING',
  STARTED = 'STARTED',
  CREATED = 'CREATED',
  ERROR = 'ERROR',
  TIMEOUT = 'TIMEOUT',
  REPORT_ERROR = 'REPORT_ERROR',
  REPORTED = 'REPORTED',
  DELETED = 'DELETED',
}

export enum MethodType {
  HILIC = 'HILIC',
  RP = 'RP',
}

export enum DimensionReductionTechnique {
  UMAP = 'UMAP',
  PCA = 'PCA',
}
